import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';
import { OAuthComponent } from './oauth/oauth.component';

@NgModule({
  declarations: [OAuthComponent],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayModule,
    B3DesignSystemWebModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [OAuthComponent],
})
export class AuthenticationModule {}
